interface ChatEmptyDescriptionProps {
  text: string
}

export function ChatEmptyDescription({ text }: ChatEmptyDescriptionProps) {
  return (
    <div className="flex flex-1 items-center gap-2.5">
      <div className="h-px flex-1 bg-ink/[0.1]" />
      <span className="text-sm text-ink/80">{text}</span>
      <div className="h-px flex-1 bg-ink/[0.1]" />
    </div>
  )
}
